import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { GET_SUBJECTS, GET_TENANT_SUBJECTS, SEARCH_SUBJECTS, CREATE_SUBJECT, GET_SECTION_SUBJECTS } from 'actions/subjects';
var INITIAL_STATE = {
  subjects: null,
  tenant: null,
  search: null,
  created: null,
  section: null
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case GET_TENANT_SUBJECTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        tenant: action.payload
      });

    case GET_SUBJECTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        subjects: action.payload
      });

    case SEARCH_SUBJECTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        search: action.payload
      });

    case CREATE_SUBJECT:
      return _objectSpread(_objectSpread({}, state), {}, {
        created: action.payload
      });

    case GET_SECTION_SUBJECTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        section: action.payload
      });

    default:
      return state;
  }
}
;